import {
	ArrayUnique,
	IsArray,
	IsBoolean,
	IsEnum,
	IsNotEmpty,
	IsNotEmptyObject,
	IsNumber,
	IsObject,
	IsOptional,
	IsString,
	IsUUID,
	Min,
	ValidateIf,
	ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';
import { DiscountTypeEnum } from '@sweatpals/shared';
import type { DiscountRelationFlags } from '@sweatpals/shared';

export enum DiscountTierEnum {
	All = 'all',
	Selected = 'selected',
}

export class DiscountFormDto<K extends string = string> {
	@IsOptional()
	@IsUUID()
	public id?: string;

	@IsString()
	@IsNotEmpty({ message: 'Enter a promo code name' })
	public code: string;

	@IsNumber()
	@Min(0)
	@IsNotEmpty({ message: 'Enter a discount' })
	public amount?: number | null;

	@IsEnum(DiscountTypeEnum)
	@IsNotEmpty()
	public type: DiscountTypeEnum;

	@ValidateIf((o) => o.tiersType === DiscountTierEnum.Selected)
	@IsNotEmpty()
	@IsObject()
	@IsNotEmptyObject(
		{
			nullable: true,
		},
		{
			message: 'Select at least one tier',
		}
	)
	public tiers: DiscountRelationFlags<K>;

	public tiersType: DiscountTierEnum;

	@IsOptional()
	@IsBoolean()
	public withMaxUses?: boolean;

	@ValidateIf(o => o.withMaxTickets)
	@IsNotEmpty()
	@IsNumber()
	@Min(0)
	public maxUses: number | null;
}

export class DiscountsFormDto {
	@IsArray()
	@ValidateNested({ each: true })
	@ArrayUnique((d) => d.code)
	@Type(() => DiscountFormDto)
	public discounts: DiscountFormDto[];
}
